document.addEventListener('DOMContentLoaded', function () {

  // /* ==========================
  //    MOBILE DRAWER
  // ========================== */

  // const mobileToggle = document.querySelector('.luxury-mobile-toggle');
  // const mobileDrawer = document.querySelector('.luxury-mobile-drawer');
  // const mobileClose = document.querySelector('.luxury-mobile-close');

  // if (!document.querySelector('.luxury-overlay')) {
  //   const overlay = document.createElement('div');
  //   overlay.className = 'luxury-overlay';
  //   document.body.appendChild(overlay);
  // }

  // const overlay = document.querySelector('.luxury-overlay');

  // if (mobileToggle) {

  //   mobileToggle.addEventListener('click', function () {

  //     mobileDrawer.classList.add('active');
  //     overlay.classList.add('active');
  //     document.body.style.overflow = 'hidden';

  //   });

  // }

  // if (mobileClose) {

  //   mobileClose.addEventListener('click', closeDrawer);

  // }

  // if (overlay) {

  //   overlay.addEventListener('click', closeDrawer);

  // }

  // function closeDrawer() {

  //   mobileDrawer.classList.remove('active');
  //   overlay.classList.remove('active');
  //   document.body.style.overflow = '';

  // }

  /* ==========================
     STICKY HEADER
  ========================== */

  const header = document.querySelector('.luxury-header-wrapper');

  window.addEventListener('scroll', function () {

    if (window.scrollY > 50) {

      header.classList.add('header-scrolled');

    } else {

      header.classList.remove('header-scrolled');

    }

  });

  /* ==========================
     PREDICTIVE SEARCH
  ========================== */

  const searchInput = document.getElementById('PredictiveSearch');
  const searchResults = document.getElementById('PredictiveResults');

  let searchTimeout;

  if (searchInput) {

    searchInput.addEventListener('keyup', function () {

      clearTimeout(searchTimeout);

      const query = this.value.trim();

      if (query.length < 2) {

        searchResults.style.display = 'none';
        searchResults.innerHTML = '';

        return;

      }

      searchTimeout = setTimeout(() => {

          fetch(
            `/search/suggest?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[limit]=8&resources[options][fields]=title,vendor,product_type,variants.title,variants.sku&section_id=predictive-search`
          )
          .then(response => response.text())
          .then(html => {

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            const content = doc.querySelector('#shopify-section-predictive-search');

            if (content && content.innerHTML.trim() !== '') {

              searchResults.innerHTML = content.innerHTML;
              searchResults.style.display = 'block';

            } else {

              searchResults.innerHTML = `
                <div class="not-found">
                  No products or collections found
                </div>
              `;

              searchResults.style.display = 'block';

            }

          })
          .catch(() => {

            searchResults.innerHTML = `
              <div class="not-found">
                Search unavailable
              </div>
            `;

            searchResults.style.display = 'block';

          });

      }, 300);

    });

  }

  /* ==========================
     CLOSE SEARCH OUTSIDE
  ========================== */

  document.addEventListener('click', function (e) {

    if (
      !e.target.closest('.luxury-search-wrapper')
    ) {

      if (searchResults) {

        searchResults.style.display = 'none';

      }

    }

  });

  /* ==========================
     ESC CLOSE
  ========================== */

  document.addEventListener('keydown', function (e) {

    if (e.key === 'Escape') {

      closeDrawer();

      if (searchResults) {

        searchResults.style.display = 'none';

      }

    }

  });

  /* ==========================
     MOBILE SUB MENU
  ========================== */

  const mobileParents =
    document.querySelectorAll('.luxury-mobile-nav .has-submenu');

  mobileParents.forEach(item => {

    const trigger = item.querySelector('.submenu-trigger');

    if (trigger) {

      trigger.addEventListener('click', function (e) {

        e.preventDefault();

        item.classList.toggle('active');

      });

    }

  });

});